import { Button } from "@chakra-ui/react";
import {
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenu as UI_DropdownMenu,
} from "components/ui/dropdown-menu";
import { toast } from "components/ui/use-toast";
import { IJustification } from "src/@types/justification";
import Edit from "@/assets/icons/edit";
import { useDialogModal } from "@/hook/handle-modal/hooks/actions";
import { useUpdateJustificationMutation } from "@/services/justification";
import statusFormat from "../../utils/status-format";
import Update from "../../update";
import { MESSAGES } from "../../utils/messages";

function DropdownMenuComponent({
  trigger,
  row,
}: {
  trigger: React.ReactNode;
  row: IJustification;
}) {
  const { icon, title, updateTo } = statusFormat(row.status);
  const [updateJustification, { isLoading }] = useUpdateJustificationMutation();
  const { handleModal } = useDialogModal();

  const alterStatus = () => {
    try {
      updateJustification({
        id: Number(row?.id),
        name: row?.name || "",
        account_id: Number(row?.account?.id),
        status: updateTo || "",
        version: row?.version || 0,
      }).unwrap();
      toast(MESSAGES.DISABLED.SUCCESS);
    } catch (err) {
      console.error(err);
      toast(MESSAGES.DISABLED.ERROR);
    }
  };

  const openModalUpdate = () => {
    handleModal({
      isOpen: true,
      element: <Update row={row} />,
      title: "Editar Justificativa",
    });
  };

  return (
    <>
      <UI_DropdownMenu>
        {" "}
        <DropdownMenuTrigger asChild>{trigger}</DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem
            style={{ cursor: "pointer" }}
            onClick={() => openModalUpdate()}
          >
            <Button
              variant="link"
              className="pointer flex items-center justify-start gap-4"
            >
              <Edit color={"black"} size={13} />
              Editar
            </Button>
          </DropdownMenuItem>
          <DropdownMenuItem style={{ cursor: "pointer" }} onClick={alterStatus}>
            <Button
              variant="link"
              className="pointer flex items-center justify-start gap-4"
              isLoading={isLoading}
            >
              {icon}
              {title}
            </Button>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </UI_DropdownMenu>{" "}
    </>
  );
}

export default DropdownMenuComponent;
